import useStyles from './styles';

function Text({ children, type = 'normal' }: TextProps) {
  const classes = useStyles();

  return <span className={classes[type]}>{children}</span>;
}

export default Text;
